// components/schema/SavedSchemasList.jsx

import React from "react"
import { prettyDate } from "./schema-storage"

export default function SavedSchemasList({
  savedSchemas,
  editingId,
  onLoadSchema,
  onExportSchema,
  onDeleteSchema,
}) {
  return (
    <div className="mt-4 pb-8">
      <h3 className="text-sm font-medium mb-2">Saved Schemas</h3>
      {savedSchemas.length === 0 ? (
        <div className="text-sm text-gray-500 dark:text-gray-400 border rounded-md p-3">
          No saved schemas yet.
        </div>
      ) : (
        <div className="space-y-2">
          {savedSchemas
            .slice()
            .sort((a, b) => (b.updatedAt || 0) - (a.updatedAt || 0))
            .map(s => (
              <div
                key={s.id}
                className={`flex items-center justify-between border rounded-md p-2 bg-white dark:bg-gray-800 dark:border-gray-700 ${
                  editingId === s.id ? "ring-1 ring-blue-500/60" : ""
                }`}
              >
                <div className="min-w-0">
                  <div className="font-medium truncate">{s.name || "Untitled"}</div>
                  <div className="text-xs text-gray-500 dark:text-gray-400">
                    Updated: {prettyDate(s.updatedAt || s.createdAt)}
                  </div>
                </div>
                <div className="flex items-center gap-2">
                  <button
                    onClick={() => onLoadSchema(s)}
                    className="px-2 py-1 rounded-md bg-blue-600 text-white hover:bg-blue-700 text-sm"
                  >
                    Load
                  </button>
                  <button
                    onClick={() => onExportSchema(s)}
                    className="px-2 py-1 rounded-md bg-gray-100 hover:bg-gray-200 text-sm
                               dark:bg-gray-700 dark:hover:bg-gray-600"
                  >
                    Export
                  </button>
                  <button
                    onClick={() => onDeleteSchema(s)}
                    className="px-2 py-1 rounded-md bg-red-50 text-red-700 hover:bg-red-100 text-sm"
                  >
                    Delete
                  </button>
                </div>
              </div>
            ))}
        </div>
      )}
    </div>
  )
}
